export default function PoweredBy() {
  return (
    <div
      className='flex justify-center items-center py-4'
      style={{ color: '#27272A' }}
    >
      <div className='pr-2'>Powered by</div>
      <img src={import.meta.env.VITE_FOOTER_LOGO} alt='bp logo' />
    </div>
  );
}
